import React from 'react';
import { Link } from 'react-router-dom';
import usePrices from '../../hooks/usePrices';
import { PAGES, GAME_META, gamePath, gameLabel } from '../../site/routes';
import { usePageSeo, Breadcrumbs, PageHeader, Section, ServerGrid, ArrowLink, CtaBand, byGame } from '../../site/ui';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: 'Serveurs Dofus', to: PAGES.servers },
];

export default function ServersPage() {
  const { servers } = usePrices();

  usePageSeo({
    title: 'Serveurs Dofus 3, Rétro et Touch : Kamas par serveur | AV Kamas',
    description: "Les 20 serveurs officiels Dofus 3, Dofus Rétro et Dofus Touch : type, économie et prix des Kamas du jour pour chaque serveur.",
    path: PAGES.servers,
    breadcrumbs: BREADCRUMBS,
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker={`${servers.length} serveurs officiels`}
        title={<>Tous les serveurs Dofus : <span className="text-yellow-400">Dofus 3, Rétro et Touch</span></>}
        intro={`Achat et vente de Kamas sur les ${servers.length} serveurs officiels d'Ankama. Chaque serveur a sa propre économie : voici ce qu'il faut savoir avant d'acheter ou de vendre vos Kamas.`}
      >
        <nav aria-label="Jeux" className="flex flex-wrap gap-2 mt-4">
          {Object.keys(GAME_META).map(game => (
            <a key={game} href={`#${GAME_META[game].slug}`} className="px-3 py-1.5 rounded-lg bg-gray-900 border border-gray-800 hover:border-yellow-500/50 text-xs sm:text-sm text-gray-300">
              {gameLabel(game)}
            </a>
          ))}
        </nav>
      </PageHeader>

      {byGame(servers).map(({ game, servers: list }, i) => (
        <Section key={game} id={GAME_META[game].slug} className={`scroll-mt-24 ${i % 2 ? 'bg-gray-900/40' : ''} ${i === 0 ? 'pt-0 md:pt-0' : ''}`}>
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-2">
            <Link to={gamePath(game)} className="hover:text-yellow-400">Kamas {gameLabel(game)}</Link>{' '}
            <span className="text-gray-500 text-sm sm:text-base font-normal">· {list.length} serveurs</span>
          </h2>
          <p className="text-sm sm:text-base text-gray-400 max-w-3xl mb-5 leading-relaxed">{GAME_META[game].intro}</p>
          <ServerGrid servers={list} />
          <div className="mt-4"><ArrowLink to={gamePath(game)}>Prix et serveurs {gameLabel(game)}</ArrowLink></div>
        </Section>
      ))}

      <CtaBand />
    </main>
  );
}
